import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('[data-process-rail]').each(function () {
		var rail = this;
		var buttons = $(rail).find('.process-rail__step');
		var panels = $(rail).find('.process-rail__panel');

		buttons.on('click', function () {
			var $btn = $(this);
			if ($btn.hasClass('is-active')) {
				return;
			}

			var targetId = $btn.data('step-target');

			buttons.removeClass('is-active').attr('aria-selected', 'false');
			$btn.addClass('is-active').attr('aria-selected', 'true');

			panels.removeClass('is-active').attr('aria-hidden', 'true');
			$(rail)
				.find('#' + targetId)
				.addClass('is-active')
				.attr('aria-hidden', 'false');
		});
	});
});